import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * a basic text box that will host the
 * table saying the next visit
 */
@Component({
  selector: 'next-visit',
  templateUrl: 'next-visit.html'
})
export class NextVisitComponent {
  @Input() nextVisit: any;
  @Input() mode: string;
  @Output() change: EventEmitter<any> = new EventEmitter();

  constructor() {

  }

  valueChange(event, attribute) {
    this.nextVisit[attribute] = event.value;
    console.log('the value emitted',event.value);
    this.change.emit(this.nextVisit);
  }

}



// WEBPACK FOOTER //
// ./src/components/next-visit/next-visit.ts